<template>
  <div class="page page_catalog">
    <CatalogHero />
    <CatalogGallery />
  </div>
</template>

<script>
import CatalogHero from '@/components/catalog/CatalogHero.vue'
import CatalogGallery from '@/components/catalog/CatalogGallery.vue'

export default {
  name: 'Catalog',
  components: { CatalogHero, CatalogGallery }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.page {
  padding: 0;
  max-width: none;
  margin: 0;

  &_catalog {
    min-height: auto;
  }
}
</style>
